import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { getFormData, logFormData } from '../../../utils/form-util';

import { Component } from '@angular/core';
import { DataMappingService } from './../../../services/data-mapping.service';
import { DatePipe } from '@angular/common';
import { JsonDataService } from './../../../services/json-data.service';
import { LanguageService } from './../../../services/language.service';
import { ModalService } from '@coreui/angular';
import { PetService } from './../../../services/pet.service';
import { SuccessDialogComponent } from './../../../dialogs/success-dialog/success-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { convertToLocalTimeToUTC } from './../../../utils/date-util';
import { environment } from './../../../../environments/environment.prod';

@Component({
  selector: 'app-pick-up-booking',
  templateUrl: './pick-up-booking.component.html',
  styleUrls: ['./pick-up-booking.component.scss']
})
export class PickUpBookingComponent {

  pickUpBookingForm: FormGroup;
  pickUpBookingData = new FormData();
  isBookingPickUp = false;
  selectedVaccinationProofFile: File | null = null;
  successModal: any;
  position = 'top-end';
  visible = false;
  percentage = 0;
  supportedLanguages = ['en', 'kh']; // Add your supported languages
  currentLanguage: string;

  // Pickup
  isPickUpServiceNeededAnswer = '';
  selectedPickUpTime: Date = new Date();
  pickUpTime = '';

  constructor(private formBuilder: FormBuilder,
    private jsonDataService: JsonDataService,
    private petService: PetService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private languageService: LanguageService,
    private dataMappingService: DataMappingService,
    private datePipe: DatePipe) {
    this.currentLanguage = this.languageService.getSelectedLanguage();
    console.log(`supportedLanguages: ${this.supportedLanguages}`);
    console.log(`currentLanguage: ${this.currentLanguage}`);

    this.pickUpBookingForm = this.formBuilder.group({
      firstName: '',
      lastName: '',
      phone: '',
      address: '',
      date: '',
      time: '',
      pickUpTime: ''

    });

    const currentDateTime = this.getCurrentDateTime();
    console.log(`currentDateTime: ${currentDateTime}`);
    console.log(`local time zone: ${this.getLocalTimeZone()}`);
  }

  onSubmit() {
    console.log(`onSubmit`);
    this.createPickUpBookingPayload();
    logFormData(this.pickUpBookingData);
    console.log(`Show success toaster`);
    this.bookPickUp();
  }

  changeLanguage(lang: string): void {
    console.log(`lang: ${lang}`);
    this.languageService.setLanguage(lang);
    this.currentLanguage = lang;
  }

  createPickUpBookingPayload() {
    const formValues = this.pickUpBookingForm.value;
    const date_time = new Date(`${formValues.date} ${formValues.time}`);
    console.log(`createPickUpUpdatePayload, date_time: ${date_time}`);
    const date_time_utc = convertToLocalTimeToUTC(`${formValues.date} ${formValues.time}`);

    this.pickUpBookingData.append('first_name', formValues.firstName);
    this.pickUpBookingData.append('last_name', formValues.lastName);
    this.pickUpBookingData.append('phone', formValues.phone);
    this.pickUpBookingData.append('address', formValues.address);
    this.pickUpBookingData.append('date_time', date_time_utc);

    console.log(`createPickUpUpdatePayload, pickUpTime: ${this.pickUpTime}`);
  }

  bookPickUp() {
    this.isBookingPickUp = true;
    logFormData(this.pickUpBookingData)
    this.petService.bookPickUp(this.pickUpBookingData).subscribe({
      next: (response) => {
        this.isBookingPickUp = false;
        console.log(`bookPickUp, response: ${JSON.stringify(response)}`);
        this.openSuccessDialog("Pick up service is successfully booked");
      },
      error: (error) => {
        this.isBookingPickUp = false;
        console.error(`bookPickUp, error: ${JSON.stringify(error)}`);
      }
    });
    this.isBookingPickUp = false;
  } // end of bookPickUp

  openSuccessDialog(message: string): void {
    const initialState: ModalOptions = {
      backdrop: 'static',
      initialState: {
        title: 'Registration',
        closeBtnName: 'Close',
      },

    };

    this.successModal = this.modalService.show(SuccessDialogComponent, initialState);
    this.successModal.content.message = message;
  }

  showErrorToast(error: string, title: string) {
    this.toastr.clear();
    this.toastr.error(error, title, environment.toastrConfig);
  }

  showSuccessToast(message: string, title: string) {
    this.toastr.clear();
    // this.toastr.success(message, title, environment.toastrConfig);
    this.toastr.success('message', 'title', {
      timeOut: 3000, // Time to close the notification in milliseconds
      progressBar: true, // Show a progress bar
      positionClass: 'toast-top-right' // Position of the notification
    });
  }

  toggleToast() {
    this.visible = !this.visible;
  }

  onVisibleChange($event: boolean) {
    this.visible = $event;
    this.percentage = !this.visible ? 0 : this.percentage;
  }

  onTimerChange($event: number) {
    this.percentage = $event * 25;
  }

  getCurrentDateTime(): string | null {
    const currentDate = new Date();
    return this.datePipe.transform(currentDate, 'yyyy-MM-dd HH:mm:ss', 'local');
  }

  getLocalTimeZone(): string {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timeZone;
  }
}
